import i18n from "i18next";
import { initReactI18next } from "react-i18next";

import translationEN from "./lang/en_EN.json";
import translationSK from "./lang/sk_SK.json";

const resources = {
  en: {
    translation: translationEN,
  },
  sk: {
    translation: translationSK,
  },
};

const lang = localStorage.getItem("lang");

if(lang === "en"){
  i18n
  .use(initReactI18next)
  .init({
    resources,
    lng: "en",
    keySeparator: false,
    interpolation: {
      escapeValue: false,
    },
  });
}else {
if(lang === null) localStorage.setItem("lang", "sk")
i18n
  .use(initReactI18next)
  .init({
    resources,
    lng: "sk",
    keySeparator: false,
    interpolation: {
      escapeValue: false,
    },
  });
}
export default i18n;
